import React from 'react';
import { Spinner } from '@skin-seoul/design-system';
const CART_LOADING_INDICATOR_TEST_ID = 'cart-loading-indicator';

const CartLoaderBackdrop = () => {
  return (
    <div
      className="absolute h-screen w-full top-0 left-0 backdrop-blur-[1px] bg-black/20 z-banner flex items-center justify-center"
      data-testid={CART_LOADING_INDICATOR_TEST_ID}
    >
      <Spinner className="text-primary-600" size="xl" />
    </div>
  );
};

export default CartLoaderBackdrop;
